import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';
import { Button } from '@els/els-react--button';
import FactsContext from '@Components/Results/substances/contexts/facts.context';
import NumberFormatter from '@Utils/NumberFormatter';
import { getFactCount } from '@Components/Results/substances/utils/factCountHelper';

function SubstanceFactLinks({ substance, onToggle }) {
  const { facts } = useContext(FactsContext);

  if (isEmpty(facts)) {
    return null;
  }

  return (
    <ul className={`substance-details-left ${facts && Object.keys(facts)?.length > 3 ? 'substance-details-left--columns' : ''}`}>
      {map(facts, (fact) => (
        <li key={fact.title}>
          <Button
            type="link"
            className={fact.className}
            aria-label={`Toggle ${fact.title}`}
            onClick={(e) => {
              e.preventDefault();
              onToggle(fact.id);
            }}>
            {fact.title} {fact.count ? <span>- {NumberFormatter(getFactCount(fact, substance), 0)}</span> : null}
          </Button>
        </li>
      ))}
    </ul>
  );
}

SubstanceFactLinks.propTypes = {
  substance: PropTypes.object.isRequired,
  onToggle: PropTypes.func.isRequired,
};

export default SubstanceFactLinks;
